import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { registerPWA } from "./lib/pwaRegistration";
import { prefetchMostVisitedRoutes } from "./lib/routeConfig";
import { initMobileFirstCSS } from "./lib/criticalCss";
import { initializeKeyboardDetection } from "./lib/keyboardDetection";
import { initAnimationOptimizations } from "./lib/animationOptimization";

// Initialize mobile-first CSS loading strategy
initMobileFirstCSS();

// Initialize keyboard detection for accessibility
initializeKeyboardDetection();

// Initialize animation optimizations for better performance
initAnimationOptimizations();

// Register PWA service worker
if ('serviceWorker' in navigator) {
  registerPWA();
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Prefetch most visited routes after initial page load
window.addEventListener('load', () => {
  prefetchMostVisitedRoutes();
});
